"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkType_1 = require("./checkType");
var defaultValue_1 = require("./defaultValue");
/**
 * zwraca wyczyszczone dane, tylko te któ®e są zgodne ze schematem
 * @param schema schemat
 * @param data dane wejściowe
 * @param checkDataType czy sprawdzać
 */
function clearData(schema, data, checkDataType) {
    if (schema.computed) {
        return undefined;
    }
    if (schema.disabled === true) {
        return defaultValue_1.default(schema, false);
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        if (data === null) {
            return null;
        }
        var result = {};
        var props = schema.properties;
        if (props) {
            for (var key in props) {
                if (props.hasOwnProperty(key)) {
                    var value = data[key];
                    var element = props[key];
                    if (value !== undefined) {
                        var nvalue = clearData(element, value, checkDataType);
                        if (nvalue !== undefined) {
                            result[key] = nvalue;
                        }
                    }
                }
            }
        }
        return result;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            var result = [];
            var items = schema.items;
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < data.length; i++) {
                var nvalue = clearData(items, data[i], checkDataType);
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        // na razie nie sprawdzamy typów danych
        if (Array.isArray(data)) {
            return undefined;
        }
        if (typeof data === 'object') {
            return undefined;
        }
        if (checkDataType && !checkType_1.default(schema, data)) {
            return undefined;
        }
        return data;
    }
}
exports.default = clearData;
//# sourceMappingURL=clearData.js.map